import React from 'react';

type ToastItem = { id: number; message: string; type: 'success' | 'error' };

export function Toast({ message, type }: { message: string; type: string }) {
  return <div className={`toast ${type}`}>{message}</div>;
}

export function ToastContainer({ toasts }: { toasts: ToastItem[] }) {
  if (toasts.length === 0) return null;
  return (
    <div className="toast-container">
      {toasts.map(t => (
        <Toast key={t.id} message={t.message} type={t.type} />
      ))}
    </div>
  );
}
